// ESM-Huelle fuer lib/scripts/components/CMP_CMessage.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CMessage(id) {
    this.construct(id);

    this.name = "CMessage";
    this.htmlType = "div";

    this.yesno = null;
    this.yesnocancel = null;
    this.ok = null;
    this.okcancel = null;

    this.properties = {
        callback: {
            cls: null,
            fnc: null
        },
        frame: {
            styles: {}
              /*  backgroundColor: "#B0DFB0",
                width: "50%",
                height: "50%",
                left: "35%",
                top: "45%",
                borderStyle: "solid",
                borderWidth: "2px",
                borderColor: "#D2ECD2",
                borderRightColor: "#3E973E",
                borderBottomColor: "#3E973E",
                zIndex: "11"
            }*/
        },
        pushPanel: {
            styles: {},
              /*  backgroundColor: "#B0DFB0",
                bottom: "15%"
            },*/
            defaultButton: {
                styles: {}
            }
        },
        text: {
            caption: {
                value: "Eine Nachricht ...",
                styles: {
                    fontSize: "2.0vh"
                }
            },
            container: {
                styles: {
                    textAlign: "left"
                }
            },
            styles: {}
              /*  backgroundColor: "#B0DFB0",
                left: "30%",
                top: "23%",
                height: "35%",
                width: "65%"
            }*/
        },
        buttons: {
            styles: {}
              /*  backgroundColor: "#86CE86",
                borderColor: "#4AB54A",
                fontWeight: "bold",
                color: "#FFFFFF"
            }*/
        },
        image: {
            styles: {}
              /*  width: "5vw",
                height: "7vh",
                top: "30%",
                left: "8%"
            }*/
        },
        styles: {}
          /*  position: "absolute",
            top: "0px",
            left: "0px",
            height: "80%",
            width: "80%",
            visibility: "hidden"
        }*/
    }
}

CMessage.prototype = new CComponent;

CMessage.prototype.prepare = function() {
    this.frame = this.addChild(CFrame);
    this.frame.properties = combine(this.frame.properties, this.properties.frame);

    this.sessions = new Array();
    this.holdMessage = false;
    this.ignoreSave = false;
    this.resultPending = false; // Doppelklick-/Doppel-Touch-Schutz, siehe gotResult()

    var resultButtons = new Array();
    var results = new Array("Ja", "Nein", "Ja", "Nein", "Abbrechen", "OK",
        "OK", "Abbrechen");
    var resultCodes = new Array("YES", "NO", "YES", "NO", "CANCEL", "OK",
        "OK", "CANCEL");
    this.images = new Array("critical", "info", "money", "question", "warning");

    for (var i = 0; i < 8; i++) {
        resultButtons.push(new CPushButton(this.id));
if (resultButtons[i].properties.caption){        
resultButtons[i].properties.caption.value = results[i];
}
        resultButtons[i].properties.events.onMousedown = this.gotResult;
        resultButtons[i].properties.attributes.onMousedown_parameter_0 = resultCodes[i];
    }

    this.yesno = this.frame.addChild(CPushPanel);
    this.yesno.properties = combine(this.yesno.properties,
        this.properties.pushPanel);
/*    this.yesno.properties.styles.width = "50%";
    this.yesno.properties.styles.height = "20%";
    this.yesno.properties.styles.left = "25%";
    this.yesno.properties.styles.visibility = "hidden";*/
    this.yesno.buttons = resultButtons.slice(0, 2);
    this.yesno.properties.columns = this.yesno.buttons.length;
    this.yesno.properties.defaultButton = combine(this.yesno.properties.defaultButton,
        this.properties.buttons);

    this.yesnocancel = this.frame.addChild(CPushPanel);
    this.yesnocancel.properties = combine(this.yesnocancel.properties,
        this.properties.pushPanel);
  /*  this.yesnocancel.properties.styles.width = "50%";
    this.yesnocancel.properties.styles.height = "20%";

    this.yesnocancel.properties.styles.left = "25%";
    this.yesnocancel.properties.styles.visibility = "hidden";*/
    this.yesnocancel.buttons = resultButtons.slice(2, 5);
    this.yesnocancel.properties.columns = this.yesnocancel.buttons.length;
    this.yesnocancel.properties.defaultButton = combine(this.yesnocancel.properties.defaultButton,
        this.properties.buttons);

    this.ok = this.frame.addChild(CPushPanel);
    this.ok.properties = combine(this.ok.properties,
        this.properties.pushPanel);
/*    this.ok.properties.styles.width = "50%";
    this.ok.properties.styles.height = "20%";
    this.ok.properties.styles.left = "25%";
    this.ok.properties.styles.visibility = "hidden";*/
    this.ok.buttons = resultButtons.slice(5, 6);
    this.ok.properties.columns = this.ok.buttons.length;
    this.ok.properties.defaultButton = combine(this.ok.properties.defaultButton,
        this.properties.buttons);

    this.okcancel = this.frame.addChild(CPushPanel);
    this.okcancel.properties = combine(this.okcancel.properties,
        this.properties.pushPanel);
   /* this.okcancel.properties.styles.width = "50%";
    this.okcancel.properties.styles.height = "20%";
    this.okcancel.properties.styles.left = "25%";
    this.okcancel.properties.styles.visibility = "hidden";*/
    this.okcancel.buttons = resultButtons.slice(6, 8);
    this.okcancel.properties.columns = this.okcancel.buttons.length;
    this.okcancel.properties.defaultButton = combine(this.okcancel.properties.defaultButton,
        this.properties.buttons);

    this.text = this.frame.addChild(CTextLabel);
    this.text.properties = combine(this.text.properties, this.properties.text);

    for (var n = 0; n < this.images.length; n++) {
        var obj = this.frame.addChild(CImage);

        obj.properties = combine(obj.properties,
            this.properties.image);
        obj.properties.attributes.src = "lib/img/messageIcons/" + this.images[n] +
            ".png";
        //obj.properties.styles.visibility = "hidden";

        this[this.images[n]] = obj; // dynamischer Property-Name statt eval
    }

    this.prepared = true;
}

CMessage.prototype.resetSession = function(sessionId) {
    this.sessions[sessionId] = new Array("active", "text", "icon", "buttons", "cls", "fnc");
    this.sessions[sessionId].active = false;
}

CMessage.prototype.killSession = function(sessionId) {
    delete this.sessions[sessionId];
}

CMessage.prototype.recoverLast = function(sessionId) {
    var me = POS.message;

    if (!me.sessions[sessionId].active)
        return;

    var text = me.sessions[sessionId].text;
    var icon = me.sessions[sessionId].icon;
    var buttons = me.sessions[sessionId].buttons;
    var cls = me.sessions[sessionId].cls;
    var fnc = me.sessions[sessionId].fnc;

    me.show(text, icon, buttons, cls, fnc);
}

CMessage.prototype.save = function(sessionId, text, icon, buttons, cls, fnc) {
    if (sessionId == 0)
        return;

    this.sessions[sessionId].active = true;
    this.sessions[sessionId].text = text;
    this.sessions[sessionId].icon = icon;
    this.sessions[sessionId].buttons = buttons;
    this.sessions[sessionId].cls = cls;
    this.sessions[sessionId].fnc = fnc;
}

CMessage.prototype.show = function(text, icon, buttons, cls, fnc) {
    try {
        var sessionId = POS.sessions.currentSession;
	var m =  document.getElementById(this.id);


        if (!this.ignoreSave)
            this.save(sessionId, text, icon, buttons, cls, fnc);
        else
            this.ignoreSave = false;

        this.resultPending = false; // neuer Dialog - Doppelklick-Sperre der letzten Antwort aufheben

        if (text) {
	    var t = m.getElementsByClassName("CTextLabel");
		t[0].innerText= htmlDecode(text);            
//this.text.caption.properties.value = text;
  //          this.text.caption.reValue();
        }

        this.resetButtons();


        if (typeof icon == "undefined" || (typeof icon != "undefined" && icon == null))
            icon = "info";

        icon = icon.toUpperCase();

       // for (var n = 0; n < this.images.length; n++) {
                var imgels= m.getElementsByTagName('img');
        for (var n = 0; n < imgels.length; n++) {
            if (imgels[n].src.toUpperCase().indexOf(icon)>-1) {
          /*      var cmd = "this." + this.images[n];
                eval(cmd + ".properties.styles.visibility = \"visible\"");
                eval(cmd + ".reStyle()");*/
		imgels[n].style.visibility="visible";
            }
	}

        switch (buttons) {
            case "YESNO":
		document.getElementById(this.yesno.id).style.visibility="visible";
                //this.yesno.properties.styles.visibility = "visible";
                break;
            case "YESNOCANCEL":
		document.getElementById(this.yesnocancel.id).style.visibility="visible";
                //this.yesnocancel.properties.styles.visibility = "visible";
                break;
            case "OKCANCEL":
                document.getElementById(this.okcancel.id).style.visibility="visible";
		//this.okcancel.properties.styles.visibility = "visible";
                break;
            default:
		document.getElementById(this.ok.id).style.visibility="visible";                
		//this.ok.properties.styles.visibility = "visible";
                break;
        }
/*
        this.yesno.reStyle();
        this.yesnocancel.reStyle();
        this.ok.reStyle();
        this.okcancel.reStyle();
*/
        if (typeof cls != "undefined")
            this.properties.callback.cls = cls;
        else
            this.properties.callback.cls = null;

        if (typeof fnc != "undefined")
            this.properties.callback.fnc = fnc;
        else
            this.properties.callback.fnc = null;

        POS.overlay.show();
/*
        this.properties.styles.visibility = "visible";
        this.reStyle();*/
 	document.getElementById(this.id).style.visibility="visible";

    } catch (e) {
        log.add(1, "Error", "CMessage.show() failed to execute", e);
    }

    log.add(3, "Info", "CMessage", text);
}

CMessage.prototype.hide = function() {
    this.resetButtons();
    document.getElementById(this.id).style.visibility="hidden";

    /*this.properties.styles.visibility = "hidden";
    this.reStyle();
*/
    if (!this.holdMessage) {
        var sessionId = POS.sessions.currentSession;
        this.resetSession(sessionId);
    } else
        this.holdMessage = false;

    POS.overlay.hide();
}

CMessage.prototype.gotResult = function(component, parameters) {
    // Schutz gegen Doppelklick/Doppel-Touch auf denselben Dialog: POS.message.hide()
    // setzt nur CSS-visibility, ein zweites mousedown-Event (z.B. Doppel-Tap am
    // Touchscreen) kann noch vor dem Repaint feuern und denselben callback (z.B.
    // Kassenuebergabe-Bestaetigung, Bon-Abschluss) ein zweites Mal auslösen.
    // Siehe [[pos-bon-doppelzahlung-fix]].
    if (POS.message.resultPending)
        return;
    POS.message.resultPending = true;

    POS.message.hide();

    var fnc = POS.message.properties.callback.fnc;
    var cls = POS.message.properties.callback.cls;
    var result = parameters[0];

    log.add(4, "Info", "CMessage result: " + result);

    if (typeof fnc == "function")
        setTimeout(fnc, 0, cls, result);
    //POS.timeout.register ("messageResult", fnc, Array (cls, result), 1, 1);
    //fnc(cls, result);
}

CMessage.prototype.gotHiddenResult = function(sessionId, result) {
    if (!this.sessions[sessionId].active)
        return;

    var fnc = this.sessions[sessionId].fnc;
    var cls = this.sessions[sessionId].cls;

    this.resetSession(sessionId);

    if (typeof fnc == "function")
        fnc(cls, result);
}

CMessage.prototype.resetButtons = function() {
   /* for (var n = 0; n < this.images.length; n++) {
        var cmd = "this." + this.images[n];
        eval(cmd + ".properties.styles.visibility = \"hidden\"");
        eval(cmd + ".reStyle()");
    }

for (var n = 0; n < this.images.length; n++)
                document.getElementById(this.images[n].id).style.visibility=="hidden";
*/
       var m =  document.getElementById(this.id);
       var imgels= m.getElementsByTagName('img');
        for (var n = 0; n < imgels.length; n++) {
                imgels[n].style.visibility="hidden";
        }



  	document.getElementById(this.yesno.id).style.visibility="hidden";
        document.getElementById(this.yesnocancel.id).style.visibility="hidden";
        document.getElementById(this.okcancel.id).style.visibility="hidden";
        document.getElementById(this.ok.id).style.visibility="hidden";

/*
    this.yesno.reStyle();
    this.yesnocancel.reStyle();
    this.ok.reStyle();
    this.okcancel.reStyle();*/
}

// Die fuenf Scanner-Methoden (resetScannerSession, saveScanner,
// recoverLastScanner, killScannerSession, sendScannerMessage) sind am
// 26.8.2026 mit dem Funkscanner entfallen - sie schickten Meldungen an das
// Funkgeraet, das es nicht mehr gibt.

CMessage.prototype.isMessageActive = function(sessId) {
    if (typeof this.sessions[sessId] != "undefined" &&
        typeof this.sessions[sessId].active != "undefined" && this.sessions[sessId].active)
        return true;
    else
        return false;
}

export { CMessage };
